import { Injectable } from '@angular/core';
import { Params } from '@angular/router';

export interface NavigationItem {
  id: string;
  title: string;
  type: 'item' | 'collapse' | 'group';
  translate?: string;
  icon?: string;
  hidden?: boolean;
  url?: string;
  classes?: string;
  exactMatch?: boolean;
  external?: boolean;
  target?: boolean;
  breadcrumbs?: boolean;
  function?: any;
  badge?: {
    title?: string;
    type?: string;
  };
  children?: Navigation[];
  qParams?: Params;
}

export interface Navigation extends NavigationItem {
  children?: NavigationItem[];
}

const NavigationItems = [
  {
    id: 'navigation',
    title: 'navigation.navigation',
    type: 'group',
    icon: 'feather icon-monitor',
    children: [
      {
        id: 'products',
        title: 'Products',
        type: 'item',
        icon: 'feather icon-shopping-cart',
        url: 'dashboard/products',

      },
      {
        id: 'catalogues',
        title: 'Catalogues',
        type: 'item',
        icon: 'feather icon-box',
        url: 'dashboard/catalogues',

      },
      {
        id: 'careers',
        title: 'Careers',
        type: 'collapse',
        icon: 'feather icon-briefcase',
        children: [
          {
            id: 'administrative',
            title: 'Administrative',
            type: 'item',
            url: '/dashboard/careers/administrative',
          },
          {
            id: 'technician',
            title: 'Technical',
            type: 'item',
            url: '/dashboard/careers/technical',
          },
        ],
      },
      {
        id: 'sliderIamges',
        title: 'Slider Images',
        type: 'item',
        icon: 'feather icon-image',
        url: 'dashboard/slider',

      },
      {
        id: 'contacts',
        title: 'Contacts',
        type: 'item',
        icon: 'feather icon-phone',
        url: '/dashboard/contact',
      },
      {
        id: 'contact-us',
        title: 'Contact us mails',
        type: 'item',
        icon: 'feather icon-mail',
        url: '/dashboard/contact-us',
        qParams: {
          page: 1
        }
      },
    ]
  }
]
@Injectable()
export class NavigationItem {
  public get() {
    return NavigationItems;
  }
}
